"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKeyText = void 0;
var keyLanguageText = [
    {
        enText: 'Negative',
        esText: 'Negativo',
        key: 'negative',
    },
    {
        enText: 'carousel',
        esText: 'carrusel',
        key: 'carousel',
    },
    {
        enText: ' per',
        esText: ' por',
        key: 'per',
    },
    {
        enText: ' month',
        esText: ' mes',
        key: 'month',
    },
    {
        enText: 'carousel buttons',
        esText: 'botones de carrusel',
        key: 'carouselButtons',
    },
    {
        enText: 'You have reached the beginning. Disabling Previous button.',
        esText: 'Has llegado al principio. Desactivando el botón anterior.',
        key: 'CarouselDisablePreBtn',
    },
    {
        enText: 'You have reached the end. Disabling Next button.',
        esText: 'Has llegado al final. Desactivando el botón Siguiente.',
        key: 'CarouselDisableNxtBtn',
    },
    {
        enText: 'Scroll Left',
        esText: 'Desplazarse a la izquierda',
        key: 'CarouselScrollLeft',
    },
    {
        enText: 'Scroll Right',
        esText: 'Desplazarse a la derecha',
        key: 'CarouselScrollRight',
    },
];
function getKeyText(key) {
    var text = null;
    var EnEsText = key ? keyLanguageText.find(function (item) { return (item.key === key); }) : null;
    if (EnEsText) {
        if (window.location.href.indexOf('es-us') > -1) {
            text = EnEsText.esText;
        }
        else {
            text = EnEsText.enText;
        }
    }
    else {
        // console.error(key + ' not found in langauge array');
    }
    return text;
}
exports.getKeyText = getKeyText;
//# sourceMappingURL=EnEsLanguageKey.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/utils/EnEsLanguageKey.js
// module id = 530
// module chunks = 8